import { render, staticRenderFns } from "./OpenItemModal.vue?vue&type=template&id=6673a23b"
import script from "./OpenItemModal.vue?vue&type=script&lang=ts"
export * from "./OpenItemModal.vue?vue&type=script&lang=ts"
import style0 from "./OpenItemModal.vue?vue&type=style&index=0&id=6673a23b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports